import React from 'react';
import useEpisodePlayersContext from '../../../../hooks/useEpisodePlayersContext';
import usePlayersContext from '../../hooks/usePlayersContext';

const Pinterest = () => {
    const { data } = useEpisodePlayersContext();
    const { episodeIndex } = usePlayersContext();
    const { episodeTitle } = data.episodes[episodeIndex];
    const { podcastImageUrl } = data;
    const currentUrl = window.location.href;
    const pinterestShareUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(currentUrl)}&media=${encodeURIComponent(podcastImageUrl)}&description=${encodeURIComponent(episodeTitle)}`;

    return (
        <a
            href={pinterestShareUrl}
            className="player-app__share-link episode-player-pinterest"
            target="_blank"
            rel="noreferrer"
        >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.9967 0C3.57384 0 0 3.58042 0 7.9967C0 11.3863 2.10613 14.2822 5.08104 15.4471C5.00864 14.8153 4.94941 13.8412 5.10736 13.1501C5.25216 12.5249 6.04195 9.17483 6.04195 9.17483C6.04195 9.17483 5.80502 8.69437 5.80502 7.99013C5.80502 6.87782 6.45002 6.04854 7.25298 6.04854C7.93747 6.04854 8.26656 6.5619 8.26656 7.174C8.26656 7.8585 7.83216 8.88523 7.60181 9.83957C7.41094 10.636 8.0033 11.2875 8.78651 11.2875C10.2081 11.2875 11.3007 9.78691 11.3007 7.62814C11.3007 5.71288 9.92514 4.3768 7.95722 4.3768C5.67997 4.3768 4.34389 6.08144 4.34389 7.84533C4.34389 8.52982 4.60715 9.26696 4.93624 9.66845C5.00206 9.74742 5.00864 9.81982 4.9889 9.8988C4.92966 10.1489 4.79144 10.6952 4.76512 10.8071C4.73221 10.9519 4.64664 10.9848 4.49526 10.9124C3.50802 10.4385 2.88934 8.97738 2.88934 7.80584C2.88934 5.28507 4.71904 2.96832 8.17442 2.96832C10.9453 2.96832 13.1041 4.94282 13.1041 7.58864C13.1041 10.3464 11.3665 12.5644 8.95763 12.5644C8.14808 12.5644 7.38461 12.1432 7.12794 11.6429C7.12794 11.6429 6.72645 13.1699 6.62773 13.545C6.45002 14.2427 5.96298 15.1115 5.63389 15.6446C6.38421 15.8749 7.174 16 8.0033 16C12.4196 16 16 12.4196 16 8.0033C15.9934 3.58042 12.413 0 7.9967 0Z" fill="white"/>
            </svg>
            <span>Pin</span>
        </a>
    );
};

export default Pinterest;
